import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import SignIn from "./pages/SignIn";
import Logout from "./pages/Logout";
import AdminOrganizations from "./pages/AdminOrganizations";
import AdminOrganizationDetail from "./pages/AdminOrganizationDetail";
import AdminUsers from "./pages/AdminUsers";
import AdminUserDetail from "./pages/AdminUserDetail";
import AdminContacts from "./pages/AdminContacts";
import AdminSubscriptions from "./pages/AdminSubscriptions";
import AdminSubscriptionDetail from "./pages/AdminSubscriptionDetail";
import AdminOrders from "./pages/AdminOrders";
import AdminProducts from "./pages/AdminProducts";
import AdminProductDetail from "./pages/AdminProductDetail";
import AdminAddProduct from "./pages/AdminAddProduct";
import AdminAccounts from "./pages/AdminAccounts";
import AdminAccountDetail from "./pages/AdminAccountDetail";
import AdminSquarespace from "./pages/AdminSquarespace";
import AdminCircle from "./pages/AdminCircle";
import CircleEvents from "./pages/CircleEvents";
import CircleEventDetail from "./pages/CircleEventDetail";
import CircleUsers from "./pages/CircleUsers";
import CircleUserDetail from "./pages/CircleUserDetail";
import SquarespacePrices from "./pages/SquarespacePrices";
import SquarespacePriceDetail from "./pages/SquarespacePriceDetail";
import SquarespaceCustomers from "./pages/SquarespaceCustomers";
import SquarespaceCustomerDetail from "./pages/SquarespaceCustomerDetail";
import SquarespaceCreateCustomer from "./pages/SquarespaceCreateCustomer";
import SquarespaceOrders from "./pages/SquarespaceOrders";
import SquarespaceOrderDetail from "./pages/SquarespaceOrderDetail";
import SquarespaceSubscriptions from "./pages/SquarespaceSubscriptions";
import SquarespaceSubscriptionDetail from "./pages/SquarespaceSubscriptionDetail";
import SquarespaceWebsites from "./pages/SquarespaceWebsites";
import SquarespaceWebsiteDetail from "./pages/SquarespaceWebsiteDetail";
import SquarespacePayloads from "./pages/SquarespacePayloads";
import SquarespacePayloadDetail from "./pages/SquarespacePayloadDetail";
import SquarespaceProcessOrder from "./pages/SquarespaceProcessOrder";
import SquarespaceDocs from "./pages/SquarespaceDocs";
import AdminSubscriptionPlans from "./pages/AdminSubscriptionPlans";
import AdminSubscriptionPlanDetail from "./pages/AdminSubscriptionPlanDetail";
import AdminFeatures from "./pages/AdminFeatures";
import AdminDocs from "./pages/AdminDocs";
import AdminEnvVars from "./pages/AdminEnvVars";
import AccessDenied from "./pages/AccessDenied";
import NotFound from "./pages/NotFound";
import AdminRoute from "./components/AdminRoute";
import SentryRouteMetrics from "./components/SentryRouteMetrics";
import AuthErrorCapture from "./components/AuthErrorCapture";

const VITE_ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;

function App() {
  useEffect(() => {
    console.log('VITE_ENVIRONMENT:', VITE_ENVIRONMENT);
  }, []);
  return (
    <>
      <AuthErrorCapture />
      <SentryRouteMetrics />
      <CssBaseline />
      <Routes>
        <Route path="/" element={<SignIn />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/access-denied" element={<AccessDenied />} />
        <Route
          path="/dashboard"
          element={
            <AdminRoute>
              <AdminFeatures />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/docs"
          element={
            <AdminRoute>
              <AdminDocs />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/env"
          element={
            <AdminRoute>
              <AdminEnvVars />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/organizations"
          element={
            <AdminRoute>
              <AdminOrganizations />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/organizations/:id"
          element={
            <AdminRoute>
              <AdminOrganizationDetail />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/users"
          element={
            <AdminRoute>
              <AdminUsers />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/users/:id"
          element={
            <AdminRoute>
              <AdminUserDetail />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/contacts"
          element={
            <AdminRoute>
              <AdminContacts />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/subscriptions"
          element={
            <AdminRoute>
              <AdminSubscriptions />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/subscriptions/:id"
          element={
            <AdminRoute>
              <AdminSubscriptionDetail />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/orders"
          element={
            <AdminRoute>
              <AdminOrders />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/products"
          element={
            <AdminRoute>
              <AdminProducts />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/products/new"
          element={
            <AdminRoute>
              <AdminAddProduct />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/products/:id"
          element={
            <AdminRoute>
              <AdminProductDetail />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/accounts"
          element={
            <AdminRoute>
              <AdminAccounts />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/accounts/:id"
          element={
            <AdminRoute>
              <AdminAccountDetail />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/squarespace"
          element={
            <AdminRoute>
              <AdminSquarespace />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/circle"
          element={
            <AdminRoute>
              <AdminCircle />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/circle/events"
          element={
            <AdminRoute>
              <CircleEvents />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/circle/events/:id"
          element={
            <AdminRoute>
              <CircleEventDetail />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/circle/users"
          element={
            <AdminRoute>
              <CircleUsers />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/circle/users/:id"
          element={
            <AdminRoute>
              <CircleUserDetail />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/squarespace/docs"
          element={
            <AdminRoute>
              <SquarespaceDocs />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/squarespace/prices"
          element={
            <AdminRoute>
              <SquarespacePrices />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/squarespace/prices/:id"
          element={
            <AdminRoute>
              <SquarespacePriceDetail />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/squarespace/customers"
          element={
            <AdminRoute>
              <SquarespaceCustomers />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/squarespace/customers/new"
          element={
            <AdminRoute>
              <SquarespaceCreateCustomer />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/squarespace/customers/:id"
          element={
            <AdminRoute>
              <SquarespaceCustomerDetail />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/squarespace/orders"
          element={
            <AdminRoute>
              <SquarespaceOrders />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/squarespace/orders/:id"
          element={
            <AdminRoute>
              <SquarespaceOrderDetail />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/squarespace/subscriptions"
          element={
            <AdminRoute>
              <SquarespaceSubscriptions />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/squarespace/subscriptions/:id"
          element={
            <AdminRoute>
              <SquarespaceSubscriptionDetail />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/squarespace/websites"
          element={
            <AdminRoute>
              <SquarespaceWebsites />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/squarespace/websites/:id"
          element={
            <AdminRoute>
              <SquarespaceWebsiteDetail />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/squarespace/payloads"
          element={
            <AdminRoute>
              <SquarespacePayloads />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/squarespace/payloads/:id"
          element={
            <AdminRoute>
              <SquarespacePayloadDetail />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/squarespace/process-order"
          element={
            <AdminRoute>
              <SquarespaceProcessOrder />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/subscription-plans"
          element={
            <AdminRoute>
              <AdminSubscriptionPlans />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/subscription-plans/:id"
          element={
            <AdminRoute>
              <AdminSubscriptionPlanDetail />
            </AdminRoute>
          }
        />
      <Route path="/404" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
